import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  additionalFieldCrudService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'additionalFieldModel',
    'listModel',
    function (
      runtimeConstant,
      $http,
      $q,
      $filter,
      webApiSettings,
      AdditionalField,
      List
    ) {
      'use strict';

      function handleError(err, status) {
        if (status === 404 || status === -1) {
          return {
            status_code: status,
            title: $filter('translate')('SERVER OFFLINE'),
            text: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
        }

        if (status === 400 && err.ModelState) {
          return {
            title: $filter('translate')('ERROR'),
            text: $filter('translate')('VERIFY FIELD ERRORS'),
            modelState: err.ModelState,
          };
        }

        return {
          title: $filter('translate')('ERROR'),
          text: $filter('translate')('ERROR SAVE ADDITIONAL FIELD'),
        };
      }

      function sortColumns() {
        return [
          {
            column: 'name',
            title: 'NAME',
            type: 'text',
            sortOrder: 'asc',
          },
          {
            column: 'type',
            title: 'TYPE',
            type: 'text',
            sortOrder: 'asc',
          },
          {
            column: 'description',
            title: 'DESCRIPTION',
            type: 'text',
            sortOrder: 'asc',
          },
        ];
      }

      function extraActions() {
        var deferred = $q.defer();
        deferred.resolve([]);
        return deferred.promise;
      }

      function listFilters() {
        var deferred = $q.defer();
        var filters = null;
        deferred.resolve(filters);
        return deferred.promise;
      }

      function list() {
        var deferred = $q.defer();
        var url = 'additionalField';

        $http.get(webApiSettings.apiServiceBaseUri + url).then(
          function (res) {
            var data = res.data;
            var result = [];

            data = resolveReferences(data);

            for (var i = 0; i < data.length; i++) {
              result.push(new AdditionalField(data[i]));
            }

            deferred.resolve(result);
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function load(id) {
        var deferred = $q.defer();

        var additionalField = new AdditionalField();
        var lists = null;
        var done = false;

        $http
          .get(webApiSettings.apiServiceBaseUri + 'lists', {
            ignoreLoadingBar: true,
          })
          .then(
            function (result) {
              var data = result.data;
              lists = [];
              data = resolveReferences(data);

              data.forEach(function (d) {
                var list = new List(d);
                lists.push(list);
              });

              if ((id && additionalField.id !== 0 && !done) || (!id && !done)) {
                additionalField.lists = lists;
                done = true;
                deferred.resolve(additionalField);
              }
            },
            function (err) {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            }
          );

        if (id) {
          $http
            .get(webApiSettings.apiServiceBaseUri + 'additionalField/' + id, {
              ignoreLoadingBar: true,
            })
            .then(
              function (result) {
                var data = result.data;
                data = resolveReferences(data);
                additionalField = new AdditionalField(data);
                if (lists !== null && !done) {
                  additionalField.lists = lists;
                  done = true;
                  deferred.resolve(additionalField);
                }
              },
              function (err) {
                var error = handleError(err.data, err.status);
                deferred.reject(error);
              }
            );
        }

        return deferred.promise;
      }

      function save(additionalField) {
        var addField = {
          id: 0,
          idCompany: additionalField.idCompany,
          idFieldType: additionalField.idFieldType,
          idList: additionalField.idList,
          name: additionalField.name,
          validationType: additionalField.validationType,
          description: additionalField.description,
        };

        var deferred = $q.defer();

        switch (additionalField.idFieldType) {
          case 7:
            additionalField.validationType = 0;
            break;
          case 3:
            additionalField.idList = null;
            additionalField.list = null;
            break;
          default:
            additionalField.validationType = 0;
            additionalField.idList = null;
            additionalField.list = null;
            break;
        }

        if (additionalField.id === 0) {
          $http
            .post(
              webApiSettings.apiServiceBaseUri + 'additionalField',
              addField,
              {
                ignoreLoadingBar: true,
              }
            )
            .then(
              function () {
                deferred.resolve();
              },
              function (err) {
                deferred.reject(handleError(err.data, err.status));
              }
            );
        } else {
          $http
            .put(
              webApiSettings.apiServiceBaseUri + 'additionalField',
              additionalField,
              {
                ignoreLoadingBar: true,
              }
            )
            .then(
              function () {
                deferred.resolve();
              },
              function (err) {
                deferred.reject(handleError(err.data, err.status));
              }
            );
        }

        return deferred.promise;
      }

      function _delete(itens) {
        var deferred = $q.defer();

        var url = 'additionalField/removelist/';
        var ids = [];
        for (var j = 0; j < itens.length; j++) {
          ids.push(itens[j].id);
        }

        $http.post(webApiSettings.apiServiceBaseUri + url, ids).then(
          function () {
            deferred.resolve(true);
          },
          function (err) {
            if (err.data.ModelState) {
              if (err.data.ModelState.additionalFieldHasDocuments) {
                deferred.reject({
                  title: $filter('translate')('HAS ASSOCIATED DOCUMENTS'),
                  text: err.data.ModelState.additionalFieldHasDocuments[0],
                });
              }
            }

            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function run() {
        try {
          var additionalFieldCrudFactory = {};

          additionalFieldCrudFactory.sortColumns = logWrapper(
            sortColumns,
            runtimeConstant.isDebugServicesInternals
          );
          additionalFieldCrudFactory.extraActions = logWrapper(
            extraActions,
            runtimeConstant.isDebugServicesInternals
          );
          additionalFieldCrudFactory.listFilters = logWrapper(
            listFilters,
            runtimeConstant.isDebugServicesInternals
          );
          additionalFieldCrudFactory.load = logWrapper(
            load,
            runtimeConstant.isDebugServicesInternals
          );
          additionalFieldCrudFactory.list = logWrapper(
            list,
            runtimeConstant.isDebugServicesInternals
          );
          additionalFieldCrudFactory.save = logWrapper(
            save,
            runtimeConstant.isDebugServicesInternals
          );
          additionalFieldCrudFactory.delete = logWrapper(
            _delete,
            runtimeConstant.isDebugServicesInternals
          );

          return additionalFieldCrudFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
